import React, { useEffect, useRef, forwardRef } from "react";
import TextArea, { TextAreaProps } from "atoms/forms/text-area";

interface AutoResizeTextAreaProps extends TextAreaProps {
    cssClassName?: string;
}

const AutoResizeTextArea = forwardRef<
    HTMLTextAreaElement,
    AutoResizeTextAreaProps
>((props, ref) => {
    const { value, onChange, rows, cssClassName = "", ...rest } = props;
    const innerRef = useRef<HTMLTextAreaElement>(null);
    const combinedRef =
        (ref as React.MutableRefObject<HTMLTextAreaElement>) || innerRef;

    useEffect(() => {
        if (combinedRef.current) {
            const el = combinedRef.current;
            el.style.height = "auto";
            el.style.height = `${el.scrollHeight}px`;
        }
    }, [value, combinedRef]);

    const handleChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
        const el = e.target;
        el.style.height = "auto";
        el.style.height = `${el.scrollHeight}px`;

        onChange(e);
    };

    return (
        <TextArea
            cssClassName={cssClassName}
            {...rest}
            ref={combinedRef}
            value={value}
            rows={rows || 1}
            onChange={handleChange}
        />
    );
});

export default AutoResizeTextArea;
